<template>
  <div class="container-fluid py-4 users-page">

    <!-- ================= HEADER ================= -->
    <div class="d-flex justify-content-between align-items-center mb-4 header-boutique flex-wrap">

      <div class="d-flex align-items-center gap-3">
        <i class="bi bi-people fs-2 text-success"></i>
        <h2 class="fw-bold mb-0">Utilisateurs</h2>
      </div>

      <button
        class="btn btn-success btn-lg shadow-sm btn-boutique mt-2 mt-md-0"
        @click="creation"
        v-if="$store.getters.hasPermission('USER_CREER')"
      >
        <i class="bi bi-plus-circle me-1"></i>
      </button>

    </div>

    <!-- ================= FILTRES ================= -->
    <div class="card shadow-sm rounded card-boutique p-3 mb-4">

      <div class="row g-3 align-items-end">

        <div class="col-12 col-md-3">
          <label class="form-label fw-semibold">Rechercher</label>
          <input
            type="text"
            v-model="searchQuery"
            placeholder="Nom, username, email..."
            class="form-control form-control-boutique"
          />
        </div>

        <div class="col-6 col-md-2">
          <label class="form-label fw-semibold">Items</label>
          <select v-model="itemsperpage" class="form-select form-select-boutique">
            <option v-for="item in itemsPerPageT" :key="item" :value="item">
              {{ item }}
            </option>
          </select>
        </div>

        <div class="col-6 col-md-3">
          <label class="form-label fw-semibold">Trier par</label>
          <select v-model="orderBy" class="form-select form-select-boutique">
            <option
              v-for="(value, key) in orderByTabs"
              :key="key"
              :value="value"
            >
              {{ key }}
            </option>
          </select>
        </div>

        <div class="col-6 col-md-2">
          <label class="form-label fw-semibold">Ordre</label>
          <select v-model="sortOrder" class="form-select form-select-boutique">
            <option
              v-for="(value, key) in sortOrders"
              :key="key"
              :value="value"
            >
              {{ key }}
            </option>
          </select>
        </div>

      </div>

    </div>

    <!-- ================= LOADER ================= -->
    <div v-if="isLoading" class="text-center my-5">
      <div class="spinner-border text-success" style="width:4rem;height:4rem;"></div>
      <p class="mt-3">Chargement des utilisateurs...</p>
    </div>

    <!-- ================= TABLE ================= -->
    <div v-else class="card shadow-sm rounded card-boutique">

      <div class="table-responsive">

        <table class="table table-hover align-middle text-center modern-table-boutique mb-0">

          <thead>
            <tr>
              <th>#</th>
              <th>Nom</th>
              <th class="d-none d-md-table-cell">Username</th>
              <th class="d-none d-sm-table-cell">Email</th>
              <th class="d-none d-md-table-cell">Rôle</th>
              <th>Statut</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>

            <tr v-for="(user, index) in filteredUsers" :key="user.id">

              <td>{{ index + 1 + (currentPage - 1) * itemsperpage }}</td>

              <td class="text-start fw-semibold">
                {{ user.nom }} {{ user.prenom }}
              </td>

              <td class="d-none d-md-table-cell">
                {{ user.username }}
              </td>

              <td class="d-none d-sm-table-cell">
                {{ user.email }}
              </td>

              <td class="d-none d-md-table-cell">
                {{ user.typeUser?.nom || '-' }}
              </td>

              <td>
                <span :class="user.enabled ? 'badge bg-success' : 'badge bg-secondary'">
                  {{ user.enabled ? 'Actif' : 'Inactif' }}
                </span>
              </td>

              <td>

                <div class="dropdown">
                  <button class="btn btn-sm btn-outline-success dropdown-toggle" data-bs-toggle="dropdown">
                    Actions
                  </button>

                  <ul class="dropdown-menu dropdown-menu-end">

                    <li v-if="$store.getters.hasPermission('USER_UPDATE')">
                      <a class="dropdown-item" @click="modifier(user.id)">
                        Modifier
                      </a>
                    </li>

                    <li v-if="$store.getters.hasPermission('USER_LOCK')">
                      <a class="dropdown-item" @click="changerStatus(user)">
                        {{ user.enabled ? 'Désactiver' : 'Activer' }}
                      </a>
                    </li>

                    <li v-if="$store.getters.hasPermission('USER_DELETE')">
                      <a class="dropdown-item text-danger" @click="supprimer(user.id)">
                        Supprimer
                      </a>
                    </li>

                  </ul>
                </div>

              </td>

            </tr>

            <tr v-if="filteredUsers.length === 0">
              <td colspan="7" class="text-center py-4">
                Aucun utilisateur trouvé
              </td>
            </tr>

          </tbody>

        </table>

      </div>

      <!-- ================= PAGINATION ================= -->
      <div class="d-flex justify-content-end p-3">

        <ul class="pagination pagination-boutique mb-0">

          <li class="page-item" :class="{ disabled: currentPage === 1 }">
            <button class="page-link" @click="changePage(currentPage - 1)">
              Précédent
            </button>
          </li>

          <li
            v-for="page in totalPages"
            :key="page"
            class="page-item"
            :class="{ active: page === currentPage }"
          >
            <button class="page-link" @click="changePage(page)">
              {{ page }}
            </button>
          </li>

          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
            <button class="page-link" @click="changePage(currentPage + 1)">
              Suivant
            </button>
          </li>

        </ul>

      </div>

    </div>

  </div>
</template>

<script>
import api from '@/api';

export default {
  data() {
    return {

      isLoading: true,
      isFirstLoad: true,

      searchQuery: '',
      itemsperpage: 10,
      orderBy: 'user.nom',
      sortOrder: 'asc',

      users: [],
      totalItems: 0,
      currentPage: 1,

      itemsPerPageT: [10, 20, 50, 100],

      orderByTabs: {
        Nom: 'user.nom',
        Username: 'user.username',
        Email: 'user.email'
      },

      sortOrders: {
        Croissant: 'asc',
        Décroissant: 'desc'
      }

    };
  },

  computed: {
     visibleUsers() {
    return this.users.filter(
      user => user.typeUser?.nom !== 'Super Admin'
    );
  },

    filteredUsers() {
  const base = this.visibleUsers;

  if (!this.searchQuery) {
    return base;
  }

  const q = this.searchQuery.toLowerCase();

  return base.filter(user =>
    `${user.nom} ${user.prenom}`.toLowerCase().includes(q) ||
    user.email?.toLowerCase().includes(q) ||
    user.username?.toLowerCase().includes(q)
  );
},

    totalPages() {
      return Math.ceil(this.totalItems / this.itemsperpage);
    }

  },

  methods: {

    creation() {
      this.$router.push({ name: 'create_utilisateur' });
    },

    modifier(id) {
      this.$router.push({ name: 'edit_user', params: { id } });
    },

    async getUsers() {

      if (this.isFirstLoad) {
        this.isLoading = true;
        this.isFirstLoad = false;
      }

      try {

        const response = await api.getItems('users', {
          page: this.currentPage,
          itemsperpage: this.itemsperpage,
          orderBy: this.orderBy,
          sortOrder: this.sortOrder,
          search: this.searchQuery
        });

        const { data, meta } = response.data;

        this.users = data;
        this.totalItems = meta?.total_records ?? data.length;

      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }

    },

    changePage(page) {
      if (page > 0 && page <= this.totalPages) {
        this.currentPage = page;
        this.getUsers();
      }
    },

    async supprimer(id) {
      if (!confirm("Voulez-vous supprimer cet utilisateur ?")) return;
      await api.deleteItem('users', id);
      this.getUsers();
    },

    async changerStatus(user) {
      await api.patchItem('users', user.id, {
        enabled: !user.enabled
      });
      this.getUsers();
    }

  },

  watch: {
    searchQuery() {
      this.currentPage = 1;
      this.getUsers();
    },
    itemsperpage() {
      this.currentPage = 1;
      this.getUsers();
    },
    orderBy() {
      this.getUsers();
    },
    sortOrder() {
      this.getUsers();
    }
  },

  created() {
    this.getUsers();
  }
};
</script>

<style scoped>

/* ================= STYLE BOUTIQUE ================= */

.users-page {
  background: #f5f7fb;
  min-height: 100vh;
}

.header-boutique {
  background: linear-gradient(135deg, #064e3b, #10b981);
  color: white;
  padding: 20px;
  border-radius: 18px;
}

.btn-boutique {
  border-radius: 12px;
}

.card-boutique {
  border: none;
  border-radius: 20px;
  background: white;
}

.form-control-boutique,
.form-select-boutique {
  border-radius: 12px;
  border: 1px solid #dbe3ec;
}

.modern-table-boutique thead {
  background: linear-gradient(135deg, #064e3b, #10b981);
  color: white;
}

.modern-table-boutique tbody tr:hover {
  background: #f8fafc;
}

.pagination-boutique .page-item.active .page-link {
  background: #10b981;
  color: white;
}

.pagination-boutique .page-link {
  border-radius: 10px;
}

</style>